/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Air_Handler_Unit_Filter_Supply_TerminalInputs */



/**
* | output |
* | --- |
* | "Terminal filter" |
*
* @param {Air_Handler_Unit_Filter_Supply_TerminalInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const air_handler_unit_filter_supply_terminal = /** @type {((inputs?: Air_Handler_Unit_Filter_Supply_TerminalInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Air_Handler_Unit_Filter_Supply_TerminalInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Terminal filter")
	return /** @type {LocalizedString} */ ("Filtre terminal")
});